module.exports = __webpack_public_path__ + "img/sistemaclinai.b6d69f7e.webp";